import React from "react";

interface SchoolTileProps {
  name: string;
  image: string;
  href: string;
}

export const SchoolTile = ({ name, image, href }: SchoolTileProps) => {
  return (
    <a className="flex flex-row md:flex-col gap-2 md:gap-0 md:w-[157px] group" href={href}>
      <div className="bg-brand-cotton rounded-1 md:rounded-lg p-1 md:p-4 w-[38px] md:w-full h-[38px] md:h-[157px] md:group-hover:p-2 transition-all">
        <img className="w-full h-full object-contain object-center mix-blend-multiply" src={image} />
      </div>
      <div className="md:py-4 md:px-2 flex items-center">
        <div className="text-base text-brand-bistre">{name}</div>
      </div>
    </a>
  );
};
